import { connect } from 'react-redux';

import { getOfficesShortList } from '../Offices/officesActions';
// Actions
import { addTaskLocation, getTaskLocation, updateTaskLocation, getLocationTypeList, archiveTaskLocation } from '../Tasks/tasksActions';
// Component
import TaskLocations from './TaskLocations';

// Store props to map with current state
const mapStateToProps = state => ({
  officesShortList: state.office.officesShortList,
  // loading
  locationListIsLoading: state.task.locationListIsLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  updateTaskLocationLoading: state.task.updateTaskLocationLoading,
  getLocationTypeListLoading: state.task.getLocationTypeListLoading,
  // data
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  locationTypeList: state.task.locationTypeList,
  isArchiving: state.task.isArchiving,
  updateTaskLocationError: state.task.updateTaskLocationError,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  updateTaskLocation: params => dispatch(updateTaskLocation(params)),
  getLocationTypeList: params => dispatch(getLocationTypeList(params)),
  archiveTaskLocation: params => dispatch(archiveTaskLocation(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(TaskLocations);
